import { useEffect, useMemo, useRef, useState } from "react";

export const useIsScrolledToBottom = (
  containerRef: React.RefObject<HTMLDivElement>
) => {
  const [isAtBottom, setIsAtBottom] = useState(false);
  const bottomMarkerRef = useRef<HTMLDivElement>(null);
  const observer = useMemo(
    () =>
      new IntersectionObserver(
        ([entry]) => {
          setIsAtBottom(entry.isIntersecting);
        },
        { root: containerRef.current, threshold: 1.0 }
      ),
    [containerRef]
  );

  useEffect(() => {
    if (bottomMarkerRef.current) {
      observer.observe(bottomMarkerRef.current);
    }

    return () => observer.disconnect();
  }, [observer]);

  return { isAtBottom, bottomMarkerRef };
};
